module.exports = __webpack_public_path__ + "static/media/rides-free-share-badge.4ce2375b.png";